import {ColorsType, StyleType} from '../../../../styles';
import {Size} from './SegmentedButton.types.web';

export const styles = (colors: ColorsType) => {
  return {
    container: {
      width: '100%',
      borderRadius: '7px',
      display: 'flex',
      justifyContent: 'space-between' as 'space-between',
      alignItems: 'center' as 'center',
      position: 'relative' as 'relative',
      overflow: 'hidden' as 'hidden',
      backgroundColor: colors?.neutral300,
      boxSizing: 'border-box',
    } as React.CSSProperties,
    slider: {
      position: 'absolute' as 'absolute',
      height: '100%',
      borderRadius: '7px',
      transition: 'transform 0.2s ease, opacity 0.1s ease',
    } as React.CSSProperties,
    item: {
      display: 'flex',
      justifyContent: 'center' as 'center',
      alignItems: 'center' as 'center',
      height: '100%',
      textAlign: 'center' as 'center',
      flexWrap: 'wrap' as 'wrap',
      cursor: 'pointer',
      zIndex: 9,
    } as React.CSSProperties,
    itemText: {
      flex: 1,
      wordBreak: 'break-word' as 'break-word',
    } as React.CSSProperties,
  };
};
